function TableHeader({ onDownload }) {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center">
          <div
            style={{
              width: "8px",
              height: "30px",
              backgroundColor: "#D18237",
              marginRight: "12px",
              borderRadius: "2px",
            }}
          />
          <h5 className="m-0 text-dark fw-bold">Employee Master List</h5>
        </div>

        {/* Export button */}
        <button
          className="btn btn-sm"
          onClick={() => onDownload()}
          style={{
            backgroundColor: "#D18237",
            borderColor: "#D18237",
            color: "white",
            transition: "all 0.3s ease",
          }}
        >
          <i className="bi bi-file-earmark-excel me-2"></i>
          Export Data
        </button>
      </div>
    </>
  );
}

export default TableHeader;
